import axios from 'axios';
import helper from '../helper';

const API_PATH = process.env.API_ENDPOINT || '';

const DEFAULT_CHUNK = 5 * 1024 * 1024;
// const DEFAULT_CHUNK = 2 * 1024 ;
const MAX_RETRY = 4;

function apiUrl(path) {
  const p = path.startsWith('/') ? path : '/' + path;
  const base = (API_PATH || '').replace(/\/$/, '');
  return base + p;
}

function authHeadersJson() {
  return {
    Authorization: 'Bearer ' + helper.getAccessToken(),
    'Content-Type': 'application/json;charset=utf-8'
  };
}

function authHeadersMultipart() {
  return {
    Authorization: 'Bearer ' + helper.getAccessToken()
  };
}

function assertSuccess(res) {
  if (!res || res.data == null) {
    throw new Error('Phản hồi không hợp lệ');
  }
  const body = res.data;
  if (body.returnCode !== 1) {
    const msg = typeof body.data === 'string' ? body.data : (body.message || 'Lỗi API');
    throw new Error(msg);
  }
  return body;
}

function mapAxiosError(e) {
  if (e && e.response && e.response.data) {
    const b = e.response.data;
    if (typeof b.data === 'string') return new Error(b.data);
    if (b.returnCode !== undefined && b.returnCode !== 1) {
      return new Error(typeof b.data === 'string' ? b.data : 'Lỗi API');
    }
  }
  return e instanceof Error ? e : new Error(String(e));
}

async function sleep(ms) {
  return new Promise((r) => setTimeout(r, ms));
}

/**
 * Upload bản ghi theo chunk + ghép server + xử lý nền (ffmpeg + storage).
 * @param {Blob|File} file
 * @param {string|number} scheduleId
 * @param {object} [opts]
 * @param {number} [opts.chunkSizeBytes]
 * @param {(done:number, total:number) => void} [opts.onProgress]
 */
export async function uploadLivestreamRecordBlob(file, scheduleId, opts) {
  const chunkSizeBytes = (opts && opts.chunkSizeBytes) || DEFAULT_CHUNK;
  const onProgress = opts && opts.onProgress;
  const sid = Number(scheduleId);
  if (!Number.isFinite(sid)) {
    throw new Error('scheduleId không hợp lệ');
  }
  const name = (file && file.name) ? file.name : 'livestream.webm';
  const total = file.size;
  const totalChunks = Math.ceil(total / chunkSizeBytes) || 1;

  let initRes;
  try {
    initRes = assertSuccess(
      await axios.post(
        apiUrl('/livestream/saveRecordChunkInit'),
        { scheduleId: sid, fileName: name, totalChunks },
        { headers: authHeadersJson() }
      )
    );
  } catch (e) {
    throw mapAxiosError(e);
  }
  const uploadId = initRes.data && initRes.data.uploadId;
  if (!uploadId) {
    throw new Error('Thiếu uploadId');
  }

  for (let i = 0; i < totalChunks; i++) {
    const start = i * chunkSizeBytes;
    const end = Math.min(start + chunkSizeBytes, total);
    const chunkBlob = file.slice(start, end);
    await postChunkWithRetry(uploadId, i, chunkBlob);
    if (onProgress) {
      onProgress(i + 1, totalChunks);
    }
  }

  let doneRes;
  try {
    doneRes = assertSuccess(
      await axios.post(
        apiUrl('/livestream/saveRecordChunkComplete'),
        { uploadId },
        { headers: authHeadersJson() }
      )
    );
  } catch (e) {
    throw mapAxiosError(e);
  }
  return doneRes;
}

async function postChunkWithRetry(uploadId, chunkIndex, chunkBlob) {
  let lastErr;
  for (let attempt = 0; attempt < MAX_RETRY; attempt++) {
    try {
      const fd = new FormData();
      fd.append('uploadId', uploadId);
      fd.append('chunkIndex', String(chunkIndex));
      fd.append('file', chunkBlob, 'part.bin');
      assertSuccess(
        await axios.post(apiUrl('/livestream/saveRecordChunk'), fd, {
          headers: authHeadersMultipart()
        })
      );
      return;
    } catch (e) {
      lastErr = mapAxiosError(e);
      await sleep(400 * (attempt + 1));
    }
  }
  throw lastErr || new Error('Upload chunk thất bại');
}

/**
 * Hủy phiên chunk trên server (xóa thư mục tạm).
 */
export async function abortLivestreamChunkUpload(uploadId) {
  if (!uploadId) return;
  try {
    await axios.delete(apiUrl('/livestream/saveRecordChunkAbort'), {
      params: { uploadId },
      headers: authHeadersMultipart()
    });
  } catch (_) {
    /* ignore */
  }
}
